/**
 * @description Can be swapped with the primary gray color.
 */

const grayWarm = {
  25: "#FDFDFC",
  50: "#FAFAF9",
  100: "#F5F5F4",
  200: "#E7E5E4",
  300: "#D7D3D0",
  400: "#A9A29D",
  500: "#79716B",
  600: "#57534E",
  700: "#44403C",
  800: "#292524",
  900: "#1C1917",
  950: "#171412",
};

export default grayWarm;
